import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../styles/ButtonS3Uploader.css';
import ReactS3Uploader from 'react-s3-uploader';
import { Circle } from 'rc-progress';
import Spinner from './Spinner/Spinner';
import AuthManager from '../utils/AuthManager';
import { maxTableCount } from '../../config/config'

class ButtonS3Uploader extends Component {
    state = {
        uploading: false,
        percent: 0
    }

    handleError = (error) => {
        this.reactS3uploader.clear();
        this.setState({ uploading: false });
        if (this.props.onError)
            this.props.onError(error)
    }

    checkFileExtension = (file) => {
        if (this.props.validateExtension) {
            if (file) {
                var validExts = this.props.validateExtension.split(',');
                var fileExt = file.name;
                fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
                if (validExts.indexOf(fileExt) < 0) {
                    this.handleError(new Error('Invalid file selected, valid files are of ' + validExts.toString() + ' types.'));
                    return false;
                }
                return true;
            }
            return false;
        }
        return true;
    }

    canUpload = (file) => {
        if (file) {
            console.log('canUpload.file:', file)

            // does file respect dynamo regex pattern? TODO: This doesn't work. Pattern works here https://regex101.com/r/xl1z0m/2/
            // Also, the pattern that Dynamo is reporting is different: [a-zA-Z0-9_.-]+    WHY is this not working?
            // We should prevent a name with () in it from being uploaded
            // const regexPattern = '^[a-zA-Z0-9_.\-\s]+$'
            // const regex = RegExp(regexPattern)
            // console.log('filename:',file.name)
            // if(!regex.test(file.name)){
            //     this.handleError(new Error(`The filename '${file.name}' does not match regular expression pattern ${regexPattern}`));
            //     return false;
            // }

            // is file a empty file
            if (file.size <= 0) {
                this.handleError(new Error(`The size of uploaded file is zero. Please upload a valid file.`));
                return false;
            }

            // is file greather than 100 MB?
            if (file.size > 104857600) {
                this.handleError(new Error(`The size of file '${file.name}' cannot exceed 100 MB`));
                return false;
            }

            // does the org have more than 100 tables?
            const findIndex = this.props.csvdata.find(x => x.fileName === file.name)
            if (!findIndex && this.props.csvdata.length >= maxTableCount) { // New file requested to be uploaded (not an update) + already have 5 files
                this.handleError(new Error('An organization can have up to ' + maxTableCount + ' Tables.'));
                return false;
            }

            return true;
        }
        return false;
    }

    onUploadStart = (file, next) => {
        console.log('onUploadStart')
        if (!this.checkFileExtension(file)) return
        if (!this.canUpload(file)) return

        const findIndex = this.props.csvdata.find(x => x.fileName === file.name)
        console.log(findIndex)
        //Check if same file name is uploaded for update
        if (this.props.processName === "upload" && findIndex) {
            this.handleError(new Error(`The file '${file.name}' has already been uploaded. Please use Update`))
            return
        } else if (this.props.processName === "update" && this.props.fileName !== file.name) {
            console.log(this.props.fileName)
            this.handleError(new Error(`The file uploaded should have the same name as '${this.props.fileName}'`))
            return
        }

        this.setState({ uploading: true, percent: 0 });
        next(file);
    }

    onUploadProgress = (percent, message) => {
        if (percent > 0) {
            this.setState({
                percent: percent
            });
        }
    }

    onUploadFinish = (signResult) => {
        this.setState({
            uploading: false
        });
        if (this.props.onFinish) {
            this.props.onFinish(signResult);
        }
    }

    getUploadSignedUrl = (file, callback) => {
        let fileName = this.props.fileName ? this.props.fileName : file.name;
        fileName = fileName.replace(/\s/g, '');
        AuthManager.uploadFile(fileName, file.type).then(response => {
            if (response.success) {
                console.log('Got signed url for upload: ' + response.preSignedUrl);
                callback({ signedUrl: response.preSignedUrl });
            } else {
                this.handleError(response.message);
            }
        }, error => {
            this.handleError(error);
        }).catch(error => {
            this.handleError(error);
        });
    }

    renderIcon() {
        if (this.state.uploading) {
            if (this.state.percent === 0) {
                return <Spinner className="ButtonS3Uploader-spiner" spinColor={this.props.spinColor} spinAlignment={this.props.spinAlignment} />;
            }
            return <span className="ButtonS3Uploader-circleSpan"><Circle percent={this.state.percent} strokeWidth="20" strokeLinecap="round" strokeColor='#FFFFFF' className='ButtonS3Uploader-circle' /></span>;
        }

        return this.props.icon;
    }

    render() {
        const {
            children,
            bsStyle,
            bsSize,
            disabled,
            icon,
            onError,
            onFinish,
            spinColor,
            spinAlignment,
            fileName,
            validateExtension,
            processName,
            ...other
        } = this.props;

        const divClass = 'btn btn-' + bsStyle + (bsSize ? ' btn-' + bsSize : '') + ' ButtonS3Uploader-btn-file';
        const props = {
            accept: this.props.accept, getSignedUrl: this.getUploadSignedUrl, onError: this.handleError, ref: (obj) => { this.reactS3uploader = obj; },
            preprocess: this.onUploadStart, onProgress: this.onUploadProgress, onFinish: this.onUploadFinish
        };
        const buttonDisabled = disabled || this.state.uploading;
        return (
            <div className={divClass} disabled={buttonDisabled}>
                {this.renderIcon()}
                {children}
                <ReactS3Uploader {...other} {...props} />
            </div>
        );
    }
}

ButtonS3Uploader.propTypes = {
    children: PropTypes.node,
    bsStyle: PropTypes.oneOf(['success', 'warning', 'danger', 'info', 'default', 'primary']).isRequired,
    bsSize: PropTypes.oneOf(['xs', 'sm', 'lg']),
    disabled: PropTypes.bool,
    icon: PropTypes.node,
    accept: PropTypes.string,
    onError: PropTypes.func,
    onFinish: PropTypes.func,
    spinColor: PropTypes.string,
    spinAlignment: PropTypes.string,
    fileName: PropTypes.string,
    validateExtension: PropTypes.string,
    processName: PropTypes.string
};

ButtonS3Uploader.defaultProps = {
    children: null,
    bsStyle: 'default',
    disabled: false,
    spinColor: '#fff',
    spinAlignment: 'left'
};

export default ButtonS3Uploader;